import { container } from '../services/container'
import Checkbox from '../components/Checkbox'
import Flash from '../components/Parts/Flash'
import { User } from '../core/User'
import { errorStore } from '../store/errorStore'
export const auth = {
	data () {
		return {
			form: {},
			error: null,
			state: null,
			loadingLogin: false,
			checkboxSignup: false,
			errorStore: errorStore.state
		}
	},

	components: {
		Checkbox,
		Flash
	},

	computed: {
		$_auth_signupDisabled () {
			if (!this.checkboxSignup || this.loadingLogin) return true
			return false
		}
	},

	methods: {
		$_auth_login (provider, redirectAfterLogin) {
			if (provider) { return container.get('services.oauth').providerSignIn(provider, {}, redirectAfterLogin) }

			this.loadingLogin = true

			container.get('services.oauth').signIn(this.form).then(response => {
				return container.get('services.oauth').authenticate()
			}).then(response => {
				return this.$root.updateUser(new User(response.body.data.resource))
			}).then(response => {
				this.error = null
				this.loadingLogin = false
			}).catch(response => {
				this.loadingLogin = false
				this.error = errorStore.format(response)
				this.state = 'error'
			})
		},

		$_auth_register () {
				this.loadingLogin = true

				container.get('services.oauth').signUp(this.form).then(response => {
					this.error = null
					return this.$_auth_login()
				}).catch(response => {
					this.loadingLogin = false
					this.error = errorStore.format(response)
					this.state = 'error'
				})
			},

		$_auth_logout () {
			this.loadingLogout = true

			const logout = () => {
				container.get('services.oauth').logout()
				this.$root.updateUser(null)
			}

			this.$root.unsubscribe().then(response => {
				logout()
			}).catch(response => {
				logout()
			})
			
		},

		$_auth_inputEmail ($event) {
			this.form.email = $event.target.value
			this.form.username = $event.target.value
		}
	}
}